/**
 * @generated SignedSource<<d738a131d4bcdaaaf682d4049b5f0e5e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type courseSectionsPreview$data = {
  readonly id: string;
  readonly sections: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"courseSectionsPreview_section">;
  }>;
  readonly " $fragmentType": "courseSectionsPreview";
};
export type courseSectionsPreview$key = {
  readonly " $data"?: courseSectionsPreview$data;
  readonly " $fragmentSpreads": FragmentRefs<"courseSectionsPreview">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "courseSectionsPreview",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "status",
          "value": "ACTIVE"
        }
      ],
      "concreteType": "CourseSection",
      "kind": "LinkedField",
      "name": "sections",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "courseSectionsPreview_section"
        }
      ],
      "storageKey": "sections(status:\"ACTIVE\")"
    }
  ],
  "type": "Course",
  "abstractKey": null
};
})();

(node as any).hash = "59533e3e7d0d52e6c2ba4f6374c064b3";

export default node;
